import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { BookOpen, Quote, MapPin } from "lucide-react";
import SectionHeading from "@/components/common/SectionHeading";
import { BOOK_META, BOOK_SPREAD_URL } from "@/lib/constants";

export default function BookDetailsSection() {
  return (
    <section id="book-details" className="relative py-20 bg-[hsl(var(--kotz-ink))]">
      <div className="absolute inset-0 bg-grain opacity-30 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Inside the Book"
          title="THE ADVENTURE OF MOYA AND KOTZINON"
          subtitle="A boy. A forest under threat. And the arrival of a superhero who was born from a father's love."
          align="center"
          className="mx-auto mb-12"
        />

        <div className="grid lg:grid-cols-12 gap-10 items-start">
          {/* Full book spread */}
          <div className="lg:col-span-7">
            <div className="rounded-3xl border border-border overflow-hidden bg-black shadow-[0_40px_120px_-40px_rgba(0,0,0,0.9)]">
              <img
                src={BOOK_SPREAD_URL}
                alt="Kotzinons book — full front & back cover spread"
                className="w-full h-auto block"
                loading="lazy"
                data-testid="storybook-spread-image"
              />
            </div>
            <p className="mt-3 text-xs font-mono uppercase tracking-[0.2em] text-foreground/45 text-center">
              Original printed spread — front (right) and back (left)
            </p>
          </div>

          {/* Synopsis + credits */}
          <div className="lg:col-span-5 space-y-5">
            <Card className="p-6 rounded-2xl border border-border bg-[hsl(var(--kotz-ink-2))]">
              <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-[0.25em] text-[hsl(var(--kotz-gold))]">
                <BookOpen className="h-3 w-3" /> Synopsis
              </div>
              <h3 className="mt-2 font-display text-2xl tracking-wider text-foreground">
                A FOREST WORTH FIGHTING FOR
              </h3>
              <p className="mt-3 text-sm sm:text-base text-foreground/70 leading-relaxed">
                Tomorrow, the workers of the Smith company arrive to cut down the forest and pave it
                over with buildings and roads. Moya refuses to accept it &mdash; the forest belongs
                to Dingo the dog and every animal that lives there. Just when it seems hopeless, help
                arrives from another world: <span className="text-[hsl(var(--kotz-gold))] font-semibold">Kotzinon</span> and{" "}
                <span className="text-[hsl(var(--kotz-red))] font-semibold">Kotzinena</span> land
                on Earth without their powers. A friendship is born, and together with Moya they
                gather the Kotzinons to restore their strength and save the forest.
              </p>
            </Card>

            <Card className="relative p-6 rounded-2xl border border-[hsl(var(--kotz-gold))]/30 bg-[hsl(var(--kotz-ink-2))] overflow-hidden">
              <Quote className="absolute top-4 left-4 h-8 w-8 text-foreground/10" />
              <p className="relative font-serif italic text-lg text-foreground/90 leading-snug">
                &ldquo;Words have no limits &mdash; they can save a world.&rdquo;
              </p>
              <p className="relative mt-3 text-[10px] font-mono uppercase tracking-[0.3em] text-[hsl(var(--kotz-gold))]">
                — Uri Menashe Eini
              </p>
            </Card>

            <div className="grid grid-cols-2 gap-3">
              <div className="p-4 rounded-xl border border-border bg-[hsl(var(--kotz-ink-2))]/60">
                <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-foreground/45">
                  Language
                </div>
                <div className="mt-1 text-sm text-foreground">{BOOK_META.language}</div>
              </div>
              <div className="p-4 rounded-xl border border-border bg-[hsl(var(--kotz-ink-2))]/60">
                <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-foreground/45">
                  Series
                </div>
                <div className="mt-1 text-sm text-foreground">{BOOK_META.series}</div>
              </div>
            </div>

            <Badge
              variant="outline"
              className="text-[10px] font-mono uppercase tracking-[0.25em] border-border text-foreground/65"
            >
              <MapPin className="h-3 w-3 mr-1" /> Printed in Israel · {BOOK_META.publisher}
            </Badge>
          </div>
        </div>
      </div>
    </section>
  );
}
